// extracted by mini-css-extract-plugin
module.exports = {"container":"e_dA","pending":"e_eA","slider":"e_fA","imageContainer":"e_gA","image":"e_hA","button":"e_iA","prevButton":"e_jA","nextButton":"e_kA","disabled":"e_lA"};